import React from "react";
import useStore from "../store";
import strings from "../lang/Localiz";

function HudPrize() {
    const i = useStore((state) => state.i);
    const current = i < 1 ? -1 : Math.ceil(i / 17);
    let prize = current >= 7 ? 7 : current;

    return (
        <div className={"hud-prize"}>
            <div className={"hud-prize-txt"}>
                {i != 103 && strings.formatString(strings.nextPrize, <br/>)}
            </div>
            {
                <>
                    {prize === -1 && (
                        <>
                            <div className={"hud-prize-img" + " paint"}/>
                            <div className={"hud-prize-img" + " bronze-contract"}/>
                        </>
                    )}
                    {prize === 1 && (
                        <>
                            <div className={"hud-prize-img" + " snowball"}>
                                <div className={"count-sp-prize"}>100</div>
                            </div>
                        </>
                    )}
                    {prize === 2 && (
                        <>
                            <div className={"hud-prize-img" + " king"}>
                                <div className={"count-sp-prize"}>10</div>
                            </div>
                        </>
                    )}
                    {prize === 3 && (
                        <>
                            <div className={"hud-prize-img" + " gauss-ice"}/>
                        </>
                    )}
                    {prize === 4 && (
                        <>
                            <div className={"hud-prize-img" + " hammer-ice"}/>
                        </>
                    )}
                    {prize === 5 && (
                        <>
                            <div className={"hud-prize-img" + " magnum-carronade"}/>
                        </>
                    )}
                    {prize === 6 && <div className={"hud-prize-img" + " magnum-ice"}/>}
                </>
            }
        </div>
    );
}

export default HudPrize;
